import {
	VALIDATION_MESSAGES,
	passwordValidation,
} from '@/constants/validation';
import { object, ref, string } from 'yup';

export type CreateUsernameAndPasswordFormData = {
	username: string;
	password: string;
	confirmPassword: string;
};

export const schema = object({
	username: string().trim().required(VALIDATION_MESSAGES.required),
	password: passwordValidation.required(VALIDATION_MESSAGES.required),
	confirmPassword: string()
		.required(VALIDATION_MESSAGES.required)
		.oneOf([ref('password')], 'Passwords do not match'),
});

export const defaultValues = {
	username: '',
	password: '',
	confirmPassword: '',
};
